import { render, staticRenderFns } from "./editar-estabelecimento.vue?vue&type=template&id=11076b12&"
import script from "./editar-estabelecimento.vue?vue&type=script&lang=ts&"
export * from "./editar-estabelecimento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11076b12')) {
      api.createRecord('11076b12', component.options)
    } else {
      api.reload('11076b12', component.options)
    }
    module.hot.accept("./editar-estabelecimento.vue?vue&type=template&id=11076b12&", function () {
      api.rerender('11076b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/estabelecimento/editar-estabelecimento.vue"
export default component.exports